module.exports = __webpack_public_path__ + "assets/202509252035/img/screenshot-20241203-171601.4faa2ea6.png";